import * as angular from 'angular';

"use strict";
angular.module('EnterDataService', []);

export default 'EnterDataService'